export default __webpack_public_path__ + "static/media/UNFI-BNB.673f1ccb.svg";